import {Suspense, useEffect} from 'react';
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import {useAuthStateManager} from './hooks/useAuthStateManager';
import Layout from './components/layout/Layout';
import RouteRedirect from './components/utility/RouteRedirect';
import Spinner from './components/utility/Spinner';
import PageNotFound from './PageNotFound';
import pages, {Page} from './pages';
import {RoutePaths} from './RoutePaths';

/** Remembers where the visitor was heading, then sends them to log in. */
const RequireLogin = () => {
    const {setSignInRedirect} = useAuthStateManager();
    const {pathname, search} = useLocation();

    useEffect(() => {
        setSignInRedirect(`${pathname}${search}`);
        // setSignInRedirect is recreated with the auth provider; the path is
        // what matters here.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname, search]);

    return <Navigate to={RoutePaths.accounts.login()} replace />;
};

function AppRoutes() {
    const {isAuthorizedForResource} = useAuthStateManager();

    const renderElement = (page: Page) => {
        if (page.redirectTo) {
            return <RouteRedirect to={page.redirectTo} />;
        }

        if (!isAuthorizedForResource(page)) {
            return <RequireLogin />;
        }

        const PageComponent = page.component;
        return <PageComponent />;
    };

    return (
        <Suspense fallback={<Spinner />}>
            <Routes>
                <Route path="/" element={<Layout />}>
                    {pages.map(page => (
                        <Route
                            key={page.path}
                            path={page.path}
                            element={renderElement(page)}
                        />
                    ))}
                    <Route path="*" element={<PageNotFound />} />
                </Route>
            </Routes>
        </Suspense>
    );
}

export default AppRoutes;
